import {
  Required,
  DataValidator,
  transformKeys,
  IsBoolean,
  IsNumber,
  IsString,
  ValidateNested,
} from "@/utils/type-vaildator";
import api from "./api";

export interface KnowledgeAddAgentUserKnowledgeFoldersByTokenResponse {
  message: string;
};


class KnowledgeAddAgentUserKnowledgeFoldersByTokenData {
  @IsString("Message must be a string")
  message: string;
}

const transformAndValidateData = (
  response: KnowledgeAddAgentUserKnowledgeFoldersByTokenResponse
): KnowledgeAddAgentUserKnowledgeFoldersByTokenData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, KnowledgeAddAgentUserKnowledgeFoldersByTokenData);
  } catch (error) {
    console.error("Knowledge add agent user knowledge folders by token data validation failed:", error.message);
    throw error;
  }
};

/** 添加指定文件夹到智能体的指定类型下 */
export const knowledgeAddAgentUserKnowledgeFoldersByToken = async ({
  agentId,
  folderIds,
  type
}: {
  agentId: string,
  folderIds: number[],
  type: string;
}) => {
  const typeMap = { video: 1, podcast: 2, moments: 3, post: 4, article: 5 } as const;

  const res = await api.post<KnowledgeAddAgentUserKnowledgeFoldersByTokenResponse>('/knowledge/add_agent_user_knowledge_folders_by_token', {
    agent_id: agentId,
    folder_id: folderIds,
    type: typeMap[type],
  });
  const data = transformAndValidateData(res.data);
  return data;
}